import moment from 'moment';
import Swal from 'sweetalert2';
import { useLocation } from "wouter";

export const gruppaBustePerMese = (results: any) => {
  return results.reduce((accumulator: { [x: string]: any[]; }, currentValue: { mese: any; anno: any; }) => {
    const { mese, anno } = currentValue;
    const key = `${mese}/${anno}`;

    if (!accumulator[key]) {
      accumulator[key] = [];
    }

    accumulator[key].push(currentValue);

    return accumulator;
  }, {});
}



export const gruppaAnno = (results: any) => {
  return results.reduce((accumulator: { [x: string]: any[]; }, currentValue: { mese: any; anno: any; }) => {
    const {  anno } = currentValue;
    const key = `${anno}`;

    if (!accumulator[key]) {
      accumulator[key] = [];
    }

    accumulator[key].push(currentValue);

    return accumulator;
  }, {});
}


export const backgroudColorByResource = (resourceType: string | undefined) => {
  switch (resourceType) {
    case 'cu':
      return 'bg-purple-700'
    case 'buste':
      return 'bg-pink-600'
    case 'documenti':
      return 'bg-yellow-500'
    case 'dipendenti':
      return 'bg-sky-700'
    default:
      return 'bg-gradient-to-r from-green-400 to-blue-500'
  }
}


export function getWeekBoundaries(currentDay: Date) {
  const now = currentDay || new Date();

  // Get the current day of the week (0 for Sunday, 6 for Saturday)
  const dayOfWeek = now.getDay();

  // Calculate the difference from the current day to Sunday
  const diffToSunday = dayOfWeek; // Difference to Sunday
  const diffToSaturday = 6 - dayOfWeek; // Difference to Saturday

  // Create a copy of the current date and set it to the start of the current week (Sunday)
  const startOfWeek = new Date(now);
  startOfWeek.setDate(now.getDate() - diffToSunday);
  startOfWeek.setHours(0, 0, 0, 0); // Set time to the start of the day

  // Create a copy of the current date and set it to the end of the current week (Saturday)
  const endOfWeek = new Date(now);
  endOfWeek.setDate(now.getDate() + diffToSaturday);
  endOfWeek.setHours(23, 59, 59, 999); // Set time to the end of the day

  return { startOfWeek, endOfWeek };
}

function addDaysToDate(date: string | number | Date, days: number) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}



export function generateDays(today = new Date()) {
  const startOfMonth = moment(today).startOf('month');
  const endOfMonth = moment(today).endOf('month');

  const startOfCalendar = startOfMonth.startOf('week');
  const endOfCalendar = endOfMonth.endOf('week');

  const days = [];
  let day = startOfCalendar;

  while (day <= endOfCalendar) {
    days.push({
      date: day.format('YYYY-MM-DD'),
      isCurrentMonth: day.isSame(startOfMonth, 'month'),
      isToday: day.isSame(moment(), 'day'),
      events: [], // This can be populated dynamically as needed
    });
    day = day.add(1, 'day');
  }

  return days;
}

export function checkSex(taxCode: string) {
  // PNSGNN89H26H501T
  // check for the position where you find 26
  let day = taxCode?.substr(9, 2);
  if (parseInt(day) > 31) {
    return 'F'
  } else {
    return 'M'
  }
}

export const decodeGiustificativoStatus = (status: string) => {
  switch (status) {
    case null:
      return 'In attesa di approvazione'
    case 'approved':
      return 'Approvato'
    case 'rejected':
      return 'Rifiutato'
    default:
      return 'In attesa di approvazione'
  }
}

export const formatHoursFromMinutes = (minutes: any) => {
  const isNegative = minutes < 0;
  const absoluteMinutes = Math.abs(minutes);
  const hours = absoluteMinutes / 60;
  const formattedHours = hours % 1 === 0 ? hours.toFixed(0) : hours.toFixed(2);
  return isNegative ? `- ${formattedHours}` : formattedHours;
};

export const hasPermission = (permission: any, profile: any) => {
  if (permission === '*') return true;
  if (profile && profile.level) {
    const firstKey = Object.keys(profile.level)[0];
    return profile.level[firstKey].includes(permission);
  }
  return false;
};
